import { render, staticRenderFns } from "./CustomerFundWalletOption.vue?vue&type=template&id=fc30f140&scoped=true"
import script from "./CustomerFundWalletOption.vue?vue&type=script&lang=js"
export * from "./CustomerFundWalletOption.vue?vue&type=script&lang=js"
import style0 from "./CustomerFundWalletOption.vue?vue&type=style&index=0&id=fc30f140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc30f140",
  null
  
)

export default component.exports